import { Controller } from '@hotwired/stimulus';

export default class FormCompletenessController extends Controller {
  static targets = ['submit'];

  connect() {
    this.element.addEventListener('input', this.check.bind(this));
    this.element.addEventListener('change', this.check.bind(this));
    this.check();
  }

  check() {
    let complete = true;
    const radioGroups = {};

    this.element.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.type === 'submit' || field.type === 'hidden') return;

      if (field.type === 'radio') {
        radioGroups[field.name] = radioGroups[field.name] || false;
        if (field.checked) radioGroups[field.name] = true;
      } else {
        if (field.value === '') complete = false;
      }
    });

    Object.keys(radioGroups).forEach(function (name) {
      if (!radioGroups[name]) complete = false;
    });

    this.submitTarget.disabled = !complete;
  }
}
